import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';
import { localDateFormat } from '../../utils';

@Injectable()
export class DateTimeHelperService {

  public readonly isoDateRegEx = new RegExp(
    '(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?',
  );

  public readonly dateFormat = localDateFormat();
  public readonly dateTimeFormat = `${this.dateFormat} HH:mm:ss`;
  public readonly defaultDateFormat = 'YYYY-MM-DD HH:mm:ss'; // Format coming from backend


  public replaceIsoUtcDatesInString(stringVal: string): string {
    if (stringVal) {
      return stringVal.replace(this.isoDateRegEx, dateVal => moment(dateVal).format('L'));
    }
  }

  public isValidDateString(dateString: string, format: string = this.defaultDateFormat): boolean {
    const cSharpMinDate = '0001-01-01T00:00:00';

    const date = moment(dateString, format);

    return dateString && !dateString.toString().includes(cSharpMinDate) && date.isValid();
  }

  public isSameDate(date1, date2): boolean {
    return (!date1 && !date2) || moment(date1).isSame(date2);
  }

  public toLocal(utcDate: string, format: string = this.dateFormat): string {
    return moment.utc(utcDate).local().format(format);
  }

  public stringToMoment(utcDate: string | Date | moment.Moment): moment.Moment {

    if (moment.isMoment(utcDate)) {
      return utcDate;
    }

    if (utcDate instanceof Date) {
      return moment(utcDate);
    }

    if (utcDate.indexOf('Z') === -1) {
      utcDate += 'Z';
    }

    return moment(utcDate);
  }

  /**
   * Creates a new Date object with today's date and a specified time.
   * If the time parameter cannot be parsed successfully, then the date returned has time set to 00:00:00
   * @param time Time, e.g. '06:30'
   */
  public timeStringToDate(time: any): Date {
    const result: Date = new Date();

    result.setHours(0);
    result.setMinutes(0);
    result.setSeconds(0);
    result.setMilliseconds(0);

    if (!time) {
      return result;
    }

    const timeString: string[] = String(time).split(':');

    if (timeString.length >= 2) {
      const hours: number = Number(timeString[0]);
      const minutes: number = Number(timeString[1]);

      if (Number.isNaN(hours) || Number.isNaN(minutes)) {
        return result;
      }

      result.setHours(Number(timeString[0]));
      result.setMinutes(Number(timeString[1]));
    }

    return result;
  }
}
